import { render, staticRenderFns } from "./RegionChatHistory.vue?vue&type=template&id=829e9c20&scoped=true"
import script from "./RegionChatHistory.vue?vue&type=script&lang=js"
export * from "./RegionChatHistory.vue?vue&type=script&lang=js"
import style0 from "./RegionChatHistory.vue?vue&type=style&index=0&id=829e9c20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829e9c20",
  null
  
)

export default component.exports